/** Audit result: statement lines the vendor says we owe that have no imported invoice. */
import { ShieldAlert, ShieldCheck, X } from "lucide-react";

const fmtMoney = (n) => `$${Number(n || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function AuditDialog({ vendor, title, audit, onClose }) {
  const missing = audit.missing || [];
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 p-4" data-testid={`${vendor}-audit-dialog`} onClick={onClose}>
      <div className="max-h-[85vh] w-full max-w-2xl overflow-hidden rounded-xl border border-white/10 bg-[#0d1017] shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3 border-b border-white/10 px-5 py-4">
          {missing.length ? <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" /> : <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-emerald-300" />}
          <div className="min-w-0 flex-1">
            <h3 className="text-sm font-bold text-white" data-testid={`${vendor}-audit-title`}>
              {missing.length
                ? `${missing.length} ${title} invoice${missing.length === 1 ? "" : "s"} on the statements with no imported invoice`
                : `Every ${title} statement invoice has a matching imported invoice`}
            </h3>
            <p className="mt-1 text-xs text-white/50">
              {audit.statement_invoices} invoices across the statements · {audit.imported_invoices} imported
              {missing.length ? <> · <b className="text-amber-200">{fmtMoney(audit.missing_total)}</b> missing paperwork</> : null}
              {audit.not_on_statement ? ` · ${audit.not_on_statement} imported invoice${audit.not_on_statement === 1 ? "" : "s"} not on any statement yet` : ""}
              {audit.notified ? " · admins notified in chat" : ""}
            </p>
          </div>
          <button type="button" onClick={onClose} aria-label="Close" data-testid={`${vendor}-audit-close`} className="rounded p-1 text-white/40 hover:bg-white/10 hover:text-white"><X className="h-4 w-4" /></button>
        </div>
        {missing.length > 0 && (
          <div className="max-h-[60vh] overflow-auto">
            <table className="w-full border-collapse text-xs">
              <thead className="sticky top-0 bg-[#0d1017]">
                <tr className="text-left font-mono text-[9px] uppercase tracking-widest text-white/40">
                  <th className="px-4 py-2">Invoice #</th><th className="px-2 py-2">PO#</th><th className="px-2 py-2">Trx date</th>
                  <th className="px-2 py-2">On statement</th><th className="px-4 py-2 text-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                {missing.map((m) => (
                  <tr key={m.invoice_number} className="border-t border-white/5 text-white/80" data-testid={`${vendor}-audit-row-${m.invoice_number}`}>
                    <td className="px-4 py-1.5 font-semibold text-white">{m.invoice_number}</td>
                    <td className="px-2 py-1.5">{m.po || "—"}</td>
                    <td className="px-2 py-1.5 whitespace-nowrap">{m.trx_date || "—"}</td>
                    <td className="px-2 py-1.5 whitespace-nowrap text-white/50">{m.statement_date}{m.account_number ? ` · acct ${m.account_number}` : ""}</td>
                    <td className="px-4 py-1.5 text-right font-semibold">{fmtMoney(m.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="border-t border-white/10 px-5 py-3 text-[11px] text-white/45">
          {missing.length ? "Scan email for the date range or import the PDFs, then audit again." : "Nothing to do."}
        </div>
      </div>
    </div>
  );
}
